import React from 'react';

const metamaskIcon = (
    _fill: string,
    size: number,
    style?: React.CSSProperties,
) => {
    return (
        <svg
            aria-hidden="true"
            data-testid="test-icon"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            id="metamask-logo"
            style={style}
        >
            <title>Metamask</title>
            <g clipPath="url(#clip0_9993_54207)">
                <path
                    d="M21.0114 2.75L13.1982 8.53117L14.6512 5.12414L21.0114 2.75Z"
                    fill="url(#paint0_linear_9993_54207)"
                />
                <path
                    d="M21.0114 2.75L13.1982 8.53117L14.6512 5.12414L21.0114 2.75Z"
                    fill="url(#paint1_linear_9993_54207)"
                />
                <path
                    d="M2.98926 2.75L10.7328 8.58512L9.34951 5.12413L2.98926 2.75Z"
                    fill="url(#paint2_linear_9993_54207)"
                />
                <path
                    d="M2.98926 2.75L10.7328 8.58512L9.34951 5.12413L2.98926 2.75Z"
                    fill="url(#paint3_linear_9993_54207)"
                />
                <path
                    d="M18.1985 16.1545L16.1196 19.3303L20.571 20.556L21.8462 16.224L18.1985 16.1545Z"
                    fill="url(#paint4_linear_9993_54207)"
                />
                <path
                    d="M18.1985 16.1545L16.1196 19.3303L20.571 20.556L21.8462 16.224L18.1985 16.1545Z"
                    fill="url(#paint5_linear_9993_54207)"
                />
                <path
                    d="M2.1626 16.224L3.43 20.556L7.87368 19.3303L5.80253 16.1545L2.1626 16.224Z"
                    fill="url(#paint6_linear_9993_54207)"
                />
                <path
                    d="M2.1626 16.224L3.43 20.556L7.87368 19.3303L5.80253 16.1545L2.1626 16.224Z"
                    fill="url(#paint7_linear_9993_54207)"
                />
                <path
                    d="M7.63394 10.7897L6.39746 12.6551L10.8025 12.8555L10.6557 8.11499L7.63394 10.7897Z"
                    fill="url(#paint8_linear_9993_54207)"
                />
                <path
                    d="M7.63394 10.7897L6.39746 12.6551L10.8025 12.8555L10.6557 8.11499L7.63394 10.7897Z"
                    fill="url(#paint9_linear_9993_54207)"
                />
                <path
                    d="M16.3667 10.7897L13.2987 8.06104L13.1982 12.8556L17.6032 12.6551L16.3667 10.7897Z"
                    fill="url(#paint10_linear_9993_54207)"
                />
                <path
                    d="M7.87354 19.3304L10.5397 18.0432L8.2445 16.2549L7.87354 19.3304Z"
                    fill="#E27625"
                />
                <path
                    d="M13.4604 18.0432L16.1189 19.3304L15.7557 16.2549L13.4604 18.0432Z"
                    fill="#E27625"
                />
                <path
                    d="M16.1189 19.3302L13.4604 18.043L13.6768 19.7696L13.6536 20.5019L16.1189 19.3302Z"
                    fill="url(#paint11_linear_9993_54207)"
                />
                <path
                    d="M7.87354 19.3302L10.3465 20.5019L10.3311 19.7696L10.5397 18.043L7.87354 19.3302Z"
                    fill="url(#paint12_radial_9993_54207)"
                />
                <path
                    d="M10.3929 15.1136L8.18262 14.4662L9.74369 13.7493L10.3929 15.1136Z"
                    fill="url(#paint13_linear_9993_54207)"
                />
                <path
                    d="M13.6084 15.1136L14.2576 13.7493L15.8264 14.4662L13.6084 15.1136Z"
                    fill="url(#paint14_linear_9993_54207)"
                />
                <path
                    d="M7.87336 19.3303L8.25979 16.1545L5.80225 16.224L7.87336 19.3303Z"
                    fill="#CC6228"
                />
                <path
                    d="M15.7402 16.1545L16.1189 19.3303L18.1978 16.224L15.7402 16.1545Z"
                    fill="#CC6228"
                />
                <path
                    d="M17.6032 12.6548L13.1982 12.8552L13.6078 15.1138L14.257 13.7494L15.8258 14.4662L17.6032 12.6548Z"
                    fill="#CC6228"
                />
                <path
                    d="M8.18265 14.4662L9.74372 13.7494L10.3929 15.1138L10.8025 12.8552L6.39746 12.6548L8.18265 14.4662Z"
                    fill="#CC6228"
                />
                <path
                    d="M6.39746 12.6548L8.24449 16.2545L8.18263 14.4662L6.39746 12.6548Z"
                    fill="#E27525"
                />
                <path
                    d="M15.8259 14.4662L15.7563 16.2545L17.6034 12.6548L15.8259 14.4662Z"
                    fill="#E27525"
                />
                <path
                    d="M10.8027 12.8555L10.3931 15.114L10.9108 17.781L11.0268 14.2661L10.8027 12.8555Z"
                    fill="#E27525"
                />
                <path
                    d="M13.1974 12.8555L12.981 14.2584L13.0892 17.781L13.6069 15.114L13.1974 12.8555Z"
                    fill="#E27525"
                />
                <path
                    d="M13.6071 15.1138L13.0894 17.7808L13.4603 18.0429L15.7556 16.2546L15.8251 14.4663L13.6071 15.1138Z"
                    fill="url(#paint15_linear_9993_54207)"
                />
                <path
                    d="M8.18262 14.4663L8.24448 16.2546L10.5397 18.0429L10.9107 17.7808L10.3929 15.1138L8.18262 14.4663Z"
                    fill="url(#paint16_linear_9993_54207)"
                />
                <path
                    d="M13.6542 20.502L13.6773 19.7697L13.4764 19.6001L10.5243 19.6001L10.3311 19.7697L10.3465 20.502L7.87354 19.3303L8.73908 20.0395L10.4934 21.2497L13.4996 21.2497L15.2616 20.0395L16.1194 19.3303L13.6542 20.502Z"
                    fill="#C0AC9D"
                />
                <path
                    d="M13.46 18.0433L13.089 17.7812L10.9097 17.7812L10.5388 18.0433L10.3301 19.77L10.5233 19.6004L13.4754 19.6004L13.6764 19.77L13.46 18.0433Z"
                    fill="url(#paint17_linear_9993_54207)"
                />
                <path
                    d="M21.3431 8.90885L22 5.71767L21.0108 2.75L13.4604 8.33849L16.3662 10.7897L20.4698 11.9845L21.374 10.9285L20.9799 10.6432L21.6058 10.0728L21.1267 9.70283L21.7527 9.22491L21.3431 8.90885Z"
                    fill="url(#paint18_linear_9993_54207)"
                />
                <path
                    d="M2 5.71791L2.66462 8.9091L2.23957 9.22516L2.87328 9.70308L2.39413 10.0731L3.02011 10.6435L2.62597 10.9287L3.53017 11.9847L7.63382 10.7899L10.5395 8.33873L2.9892 2.75024L2 5.71791Z"
                    fill="url(#paint19_linear_9993_54207)"
                />
                <path
                    d="M20.4705 11.9845L16.3669 10.7898L17.6034 12.6552L15.7563 16.2549L18.1984 16.2241L21.8461 16.2241L20.4705 11.9845Z"
                    fill="url(#paint20_radial_9993_54207)"
                />
                <path
                    d="M20.4705 11.9845L16.3669 10.7898L17.6034 12.6552L15.7563 16.2549L18.1984 16.2241L21.8461 16.2241L20.4705 11.9845Z"
                    fill="url(#paint21_linear_9993_54207)"
                />
                <path
                    d="M7.63407 10.7898L3.53047 11.9845L2.1626 16.2241L5.80254 16.2241L8.24459 16.2549L6.3976 12.6552L7.63407 10.7898Z"
                    fill="url(#paint22_radial_9993_54207)"
                />
                <path
                    d="M7.63407 10.7898L3.53047 11.9845L2.1626 16.2241L5.80254 16.2241L8.24459 16.2549L6.3976 12.6552L7.63407 10.7898Z"
                    fill="url(#paint23_linear_9993_54207)"
                />
                <path
                    d="M13.1992 12.8556L13.4619 8.33857L14.652 5.12427L9.35059 5.12427L10.5407 8.33857L10.8034 12.8556L10.9039 14.2739L10.9117 17.7812L13.091 17.7812L13.0987 14.2739L13.1992 12.8556Z"
                    fill="url(#paint24_linear_9993_54207)"
                />
            </g>
            <defs>
                <linearGradient
                    id="paint0_linear_9993_54207"
                    x1="14.1751"
                    y1="8.126"
                    x2="24.2155"
                    y2="-2.07259"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E17726" />
                    <stop offset="1" stopColor="#E17726" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_9993_54207"
                    x1="17.1744"
                    y1="8.16694"
                    x2="14.5312"
                    y2="-0.344985"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_9993_54207"
                    x1="11.4878"
                    y1="8.60035"
                    x2="1.60542"
                    y2="-1.75635"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#E27625" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_9993_54207"
                    x1="6.93005"
                    y1="8.21749"
                    x2="4.22192"
                    y2="-0.345899"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <linearGradient
                    id="paint4_linear_9993_54207"
                    x1="15.1243"
                    y1="16.1901"
                    x2="20.7392"
                    y2="24.1949"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.256463" stopColor="#E27625" />
                    <stop offset="1" stopColor="#E27625" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint5_linear_9993_54207"
                    x1="19.0339"
                    y1="20.2787"
                    x2="16.958"
                    y2="13.8429"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <linearGradient
                    id="paint6_linear_9993_54207"
                    x1="8.32455"
                    y1="16.1901"
                    x2="1.05114"
                    y2="22.8311"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.247205" stopColor="#E27625" />
                    <stop offset="1" stopColor="#E27625" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint7_linear_9993_54207"
                    x1="5.06903"
                    y1="20.2787"
                    x2="2.98854"
                    y2="13.8462"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <linearGradient
                    id="paint8_linear_9993_54207"
                    x1="7.2177"
                    y1="12.079"
                    x2="15.677"
                    y2="5.1218"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#E27625" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint9_linear_9993_54207"
                    x1="8.63922"
                    y1="12.5569"
                    x2="5.76845"
                    y2="6.20062"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <linearGradient
                    id="paint10_linear_9993_54207"
                    x1="15.44"
                    y1="12.5535"
                    x2="12.5148"
                    y2="6.14973"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <linearGradient
                    id="paint11_linear_9993_54207"
                    x1="14.7897"
                    y1="18.043"
                    x2="17.6521"
                    y2="24.4464"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#D5BFB2" />
                    <stop offset="1" stopColor="#D5BFB2" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint12_radial_9993_54207"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(10.5112 17.509) rotate(116.98) scale(12.5928 13.6543)"
                >
                    <stop stopColor="#D5BFB2" />
                    <stop offset="1" stopColor="#D5BFB2" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint13_linear_9993_54207"
                    x1="9.28774"
                    y1="13.7493"
                    x2="9.28774"
                    y2="15.1136"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#041836" />
                    <stop offset="1" stopColor="#17396B" />
                </linearGradient>
                <linearGradient
                    id="paint14_linear_9993_54207"
                    x1="14.7174"
                    y1="13.7493"
                    x2="14.7174"
                    y2="15.1136"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#041836" />
                    <stop offset="1" stopColor="#17396B" />
                </linearGradient>
                <linearGradient
                    id="paint15_linear_9993_54207"
                    x1="15.5183"
                    y1="14.4508"
                    x2="8.48202"
                    y2="22.5148"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.200338" stopColor="#F5841F" />
                    <stop offset="1" stopColor="#F5841F" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint16_linear_9993_54207"
                    x1="8.16656"
                    y1="14.4508"
                    x2="13.7797"
                    y2="21.8033"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.32798" stopColor="#F5841F" />
                    <stop offset="1" stopColor="#F5841F" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint17_linear_9993_54207"
                    x1="12.0032"
                    y1="17.7812"
                    x2="12.0032"
                    y2="19.77"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#041836" />
                    <stop offset="1" stopColor="#17396B" />
                </linearGradient>
                <linearGradient
                    id="paint18_linear_9993_54207"
                    x1="15.9241"
                    y1="10.012"
                    x2="21.9712"
                    y2="5.83055"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#592B0D" />
                    <stop offset="1" stopColor="#763E1A" />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_9993_54207"
                    x1="9.94157"
                    y1="8.72543"
                    x2="2.41488"
                    y2="4.67259"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#592B0D" />
                    <stop offset="1" stopColor="#763E1A" />
                </linearGradient>
                <radialGradient
                    id="paint20_radial_9993_54207"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(17.1692 13.1899) rotate(11.6894) scale(8.80836 9.81509)"
                >
                    <stop offset="0.263819" stopColor="#F5841F" />
                    <stop offset="1" stopColor="#F5841F" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint21_linear_9993_54207"
                    x1="18.8555"
                    y1="15.9106"
                    x2="15.9454"
                    y2="8.1841"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <radialGradient
                    id="paint22_radial_9993_54207"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8.87796 16.1901) rotate(-159.818) scale(15.5826 17.3415)"
                >
                    <stop offset="0.299865" stopColor="#F5841F" />
                    <stop
                        offset="0.567167"
                        stopColor="#F5841F"
                        stopOpacity="0"
                    />
                </radialGradient>
                <linearGradient
                    id="paint23_linear_9993_54207"
                    x1="5.25779"
                    y1="15.9106"
                    x2="2.34497"
                    y2="8.18654"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#E27625" />
                    <stop offset="1" stopColor="#FCA15C" stopOpacity="0.83" />
                </linearGradient>
                <linearGradient
                    id="paint24_linear_9993_54207"
                    x1="11.9617"
                    y1="5.1218"
                    x2="11.9617"
                    y2="30.5787"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.267932" stopColor="#F5841F" />
                    <stop offset="1" stopColor="#FFC796" stopOpacity="0.89" />
                </linearGradient>
                <clipPath id="clip0_9993_54207">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default metamaskIcon;
